/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DerivativesOrderStatus {
    DRAFT = 'Draft',
    DELETED = 'Deleted',
    FAILED = 'Failed',
    PARTIALLY_FAILED = 'PartiallyFailed',
    CANCELED = 'Canceled',
    PENDING = 'Pending',
    PARTIALLY_EXECUTED = 'PartiallyExecuted',
    EXECUTED = 'Executed',
    PAUSE = 'Pause',
}
